import { useParams } from 'react-router-dom'
import SEO from '../components/SEO'
import DocsLayout from '../components/DocsLayout'
import DocsContent from './docs/index'
import { findNavPath } from '../lib/navigation'
import { docMeta } from '../data/docMeta'

export default function Docs() {
  const { group, slug } = useParams<{ group: string; slug?: string }>()
  const currentPath = slug ? `/docs/${group}/${slug}` : `/docs/${group}`
  const { section: navSection, subsection: navSubsection } = findNavPath(currentPath)

  const meta = docMeta[currentPath]
  const pageTitle = meta?.title || (navSubsection?.label ? `Solarch — ${navSubsection.label}` : (navSection?.label ? `Solarch — ${navSection.label}` : 'Solarch Documentation'))
  const sectionTitle = navSection?.label || 'Documentation'
  const breadcrumbTitle = navSubsection?.label || navSection?.label || 'Documentation'

  const description = meta?.description || (navSubsection
    ? `${navSubsection.label} — ${sectionTitle} documentation for Solarch.`
    : `${sectionTitle} documentation for Solarch.`)

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://solarch.in'

  const breadcrumbsSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": sectionTitle,
        "item": `${siteUrl}/docs/${group}`
      },
      ...(slug ? [{
        "@type": "ListItem",
        "position": 2,
        "name": breadcrumbTitle,
        "item": `${siteUrl}${currentPath}`
      }] : [])
    ]
  };

  const techArticleSchema = slug ? {
    "@context": "https://schema.org",
    "@type": "TechArticle",
    "headline": pageTitle,
    "description": description,
    "url": `${siteUrl}${currentPath}`,
    "inLanguage": "en-US",
    "about": {
      "@id": "https://solarch.in/#software"
    },
    "author": {
      "@id": "https://solarch.in/#organization"
    },
    "publisher": {
      "@id": "https://solarch.in/#organization"
    }
  } : null;

  const jsonLd = techArticleSchema ? [breadcrumbsSchema, techArticleSchema] : breadcrumbsSchema;

  return (
    <>
      <SEO 
        title={pageTitle}
        description={description}
        canonical={currentPath}
        jsonLd={jsonLd}
      />
      <DocsLayout>
        <DocsContent />
      </DocsLayout>
    </>
  )
}
